import { createContext, useContext } from 'react';
import noop from "lodash/noop";
import styles from "./DataTable.module.css";
export var TableContext = createContext({
  styles: styles,
  columns: {
    configurable: true,
    config: [],
    setConfig: noop
  }
});
export var useTableContext = function useTableContext() {
  return useContext(TableContext);
};